import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Text, TextProps } from '@wix/design-system';

type GoodToKnowProps = {
  hasAdditionalPurchaseApps: boolean;
  textSize?: TextProps['size'];
};

const goodToKnowDescriptionsMap = {
  goodToKnowDescriptionsForStudioWithPurchases: [
    'marketplace.template-page.good-to-know-description-studio-with-purchases-1',
    'marketplace.template-page.good-to-know-description-studio-with-purchases-2',
    'marketplace.template-page.good-to-know-description-studio-with-purchases-3',
  ],
  goodToKnowDescriptionsForStudio: [
    'marketplace.template-page.good-to-know-description-studio-1',
    'marketplace.template-page.good-to-know-description-studio-2',
  ],
  goodToKnowDescriptionsForNonStudioWithPurchases: [
    'marketplace.template-page.good-to-know-description-with-purchases-1',
    'marketplace.template-page.good-to-know-description-with-purchases-2',
  ],
  goodToKnowDescriptionsForNonStudio: [
    'marketplace.template-page.good-to-know-description',
  ],
};

const GoodToKnow: FC<GoodToKnowProps> = ({
  hasAdditionalPurchaseApps,
  textSize = 'medium',
}) => {
  const getGoodToKnowDescription = (): string[] => {
    return hasAdditionalPurchaseApps
      ? goodToKnowDescriptionsMap.goodToKnowDescriptionsForStudioWithPurchases
      : goodToKnowDescriptionsMap.goodToKnowDescriptionsForStudio;
  };

  const { t } = useTranslation();
  return (
    <>
      {getGoodToKnowDescription().map((descriptionKey, index) => (
        <Text
          secondary
          size={textSize}
          dataHook={`good-to-know-description-${index}`}
          key={descriptionKey}
        >
          {t(descriptionKey)}
        </Text>
      ))}
    </>
  );
};

export default GoodToKnow;
